<template>
  <NuxtLoadingIndicator color="#e03119" />

  <NuxtPage />

  <AppModalLogin />
  <AppModalRegister />
  <AppModalForgotPassword />
  <AppModalSearch />
  <AppModalAddToCart />
  <AppModalSeatWidget />
  <AppModalSeatWidgetLtd />
  <AppModalShare />
  <AppModalContactUs />

  <ModalsContainer />
</template>

<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal'
import AppModalContactUs from '~/components/AppModalContactUs.vue'

const site = useSiteStore()
const { $i18n } = useNuxtApp()

const siteTitle = computed(() => site.data?.name ?? '')

useHead({
  titleTemplate: (title?: string) =>
    title ? `${title} | ${siteTitle.value}` : siteTitle.value,
  htmlAttrs: {
    lang: getLocale($i18n.locale.value),
  },
  bodyAttrs: {
    id: 'app-body',
  },
})

useSeoMeta({
  ogType: 'website',
  twitterCard: 'summary_large_image',
})
</script>

<style>
/* The widget sits above the modal stack and otherwise covers sheet actions. */
body:has(.ui-modal-bottom) #brevo-conversations {
  display: none !important;
}
</style>
